// extracted by mini-css-extract-plugin
module.exports = {"quick-reply-template":"quick-reply-template___1DUoj","text":"text___1-49O","description":"description___1HnA_","input":"input___3GpkN","preview":"preview___155D7"};